import { render, staticRenderFns } from "./CadastroFornecedorContaBancaria.vue?vue&type=template&id=66f140b5"
import script from "./CadastroFornecedorContaBancaria.vue?vue&type=script&lang=js"
export * from "./CadastroFornecedorContaBancaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports